export const TXTWCL_Please_enter_a_valid_postcode__ELL = {
  "id": "TXTWCL_Please_enter_a_valid_postcode__ELL",
  "defaultMessage": "Please enter a valid postcode/ZIP code."
} as const;